import { ICopyable } from '../controls/common/icopyable';
import { IDisplayableItem } from './interfaces/displayable-item.interface';
import { IUser } from './interfaces/user.interface';

export class User implements ICopyable<User>, IDisplayableItem {
    public id: string = null;
    public email: string = null;
    public firstName: string = null;
    public lastName: string = null;
    public phoneNumber: string = null;
    public mobileNumber: string = null;
    public faxNumber: string = null;
    public culture: string = null;
    public account: string = null;
    public roles: number[] = null;
    public paramSetId: number = null;
    public displayName: string = null;
    public service: string = null;

    get editableId(): string | number {
        return this['id'];
    }

    public createCopy(): User {
        const instance = new User();
        instance.id = this.id;
        instance.email = this.email;
        instance.firstName = this.firstName;
        instance.lastName = this.lastName;
        instance.phoneNumber = this.phoneNumber;
        instance.mobileNumber = this.mobileNumber;
        instance.faxNumber = this.faxNumber;
        instance.culture = this.culture;
        instance.account = this.account;
        instance.roles = [...this.roles];
        instance.paramSetId = this.paramSetId;
        instance.displayName = this.displayName;
        instance.service = this.service;

        return instance;
    }

    public static createFormCopy(user: User): IUser {
        const instance = new User();
        instance.id = user.id;
        instance.email = user.email;
        instance.firstName = user.firstName;
        instance.lastName = user.lastName;
        instance.phoneNumber = user.phoneNumber;
        instance.mobileNumber = user.mobileNumber;
        instance.faxNumber = user.faxNumber;
        instance.culture = user.culture;
        instance.account = user.account;
        instance.roles = [...user.roles];
        instance.paramSetId = user.paramSetId;
        instance.displayName = user.displayName;
        instance.service = user.service;

        return instance;
    }

    public copyFrom(other: any) {
        this.id = other.id;
        this.email = other.email;
        this.firstName = other.firstName;
        this.lastName = other.lastName;
        this.phoneNumber = other.phoneNumber;
        this.mobileNumber = other.mobileNumber;
        this.faxNumber = other.faxNumber;
        this.culture = other.culture;
        this.account = other.account;
        this.roles = [...other.roles];
        this.paramSetId = other.paramSetId;
        this.displayName = other.displayName;
        this.service = other.service;
    }

    public getDisplayName() {
        return `${this.displayName}`;
    }
}
